import React from "react";
import { RootElementContext, DefaultContext } from "./context";

export type RootProps = {
  children: React.ReactNode;
} & DefaultContext;

const DEFAULT_COLORS = [
  "rgb(0, 188,202)",
  "rgb(208,232,233)",
  "rgb(243,209,130)",
  "rgb(255,116,16)",
  "rgb(52,65,181)",
  "rgb(151,184,126)",
  "rgb(0,132,145)",
  "rgb(62,49,91)",
];

export const Root = (props: RootProps) => (
  <RootElementContext.Provider
    value={{ ...props, colors: props.colors ?? DEFAULT_COLORS }}
  >
    {props.children}
  </RootElementContext.Provider>
);

export { Donut } from "./Donut";
export { Legend } from "./Legend";
export { BarChart } from "./BarChart";
